import React from 'react'
import { ListGroup } from 'react-bootstrap'
import SearchResultCcVideo from './SearchResultCcVideo'

const SearchResultListCcVideos = ({ ccVideos, searchValue }) => {
  if(ccVideos.data.length === 0) {
    return null
  }

  const supportPath = `/support`
  const moreResultsPath = `${supportPath}?q=${encodeURIComponent(searchValue)}`

  return (
    <div className="mb-3">
      <h5>
        <a href={supportPath} className="text-dark">
          Support Videos &raquo;
        </a>
      </h5>
      <ListGroup>
        {ccVideos.data.map(result => (
          <SearchResultCcVideo key={result.id} result={result} />
        ))}
      </ListGroup>
      <div className="text-end mt-2">
        <a className="text-muted" href={supportPath}>View all support videos &raquo;</a>
      </div>
    </div>
  )
}

export default SearchResultListCcVideos
